import React, {useEffect} from 'react';
import {Card, Col, Row} from "@deere/ux.uxframe-react";
import {useDispatch, useSelector} from "react-redux";
import {getMachinesForCustomer} from "./machineSearchSlice";
import MachineList from "./MachineList";
import {useHistory, useParams} from "react-router-dom";
import {useOktaAuth} from "@okta/okta-react";
import {languageResponseData} from "../Translation/translationSerachSlice";

const CustomerMachines = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {authState} = useOktaAuth();

    const {customerEntityId} = useParams();
    let userId = '', userType = '', cusMachineSearchObject = {};

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    /*Retrieve the Customer object from history state to populate the UI*/
    const customer = history?.location?.state?.customer;


    const displayName = () => {
        let name;
        if (customer?.businessName1) {
            name = customer?.businessName1;
            name += customer?.businessName2 ? " " + customer.businessName2 : "";
        } else {
            name = customer?.firstName + " ";
            name += customer?.middleName ? customer.middleName + " " : "";
            name += customer?.lastName ? customer.lastName : "";
        }
        return name;
    }

    /* fetch the xid and send it to the API call to determine if the logged in dealer is allowed to search for the Customer Machines.*/

    useEffect(() => {
        userId = authState.idToken.claims.userID;
        userType = authState.idToken.claims.userType;
        cusMachineSearchObject = {
            "entityId": customerEntityId,
            "pageNumber": 1,
            "pageSize": 200
        }
        if (userId.startsWith("X") || userId.startsWith("x")) {
            cusMachineSearchObject = {...cusMachineSearchObject, dealerId: userId};
        }

        dispatch(getMachinesForCustomer(cusMachineSearchObject));
    }, [])
    return (
        <div>
            {/*<pre>{JSON.stringify(customer)}</pre>*/}
            <Card>
                <Card.Header>
                    <strong>{translate('customer_machines', 'Customer Machines')}</strong>
                </Card.Header>
                <Card.Body>
                    {
                        customer && (
                            <Row id="customer-info" className="mb-5">
                                <Col>
                                    {customer && customer.addresses && (
                                        <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                            <dd>{displayName()}</dd>
                                            <dd>{customer.addresses[0]?.street}
                                                {customer.addresses[0]?.street2 ? ' ' + customer.addresses[0]?.street2 : ''}
                                            </dd>
                                            <dd>{customer.addresses[0]?.city ? customer.addresses[0]?.city : ' '}
                                                {customer.addresses[0]?.state ? ', ' + customer.addresses[0]?.state : ''}
                                                {customer.addresses[0]?.country ? ', ' + customer.addresses[0]?.country : ''}
                                            </dd>
                                        </dl>
                                    )}
                                </Col>
                                <Col>
                                    <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                        <dt>{translate('home', 'Home')}</dt>
                                        <dd>{customer.homePhone?.countryCode}{customer.homePhone?.areaCode}{customer.homePhone?.phoneNumber}</dd>
                                        <dt>{translate('cell', 'Cell')}</dt>
                                        <dd>{customer.mobilePhone?.countryCode}{customer.mobilePhone?.areaCode}{customer.mobilePhone?.phoneNumber}</dd>
                                        <dt>{translate('business', 'Business')}</dt>
                                        <dd>{customer.workPhone?.countryCode}{customer.workPhone?.areaCode}{customer.workPhone?.phoneNumber}</dd>
                                        <dt>{translate('CKC', 'CKC')} #</dt>
                                        <dd>{customer.entityId}</dd>
                                    </dl>
                                </Col>
                            </Row>
                        )
                    }
                    <Row>
                        <table className="table table-sm table-uxf-modern">

                        </table>
                    </Row>
                </Card.Body>
            </Card>
            <Card>
                <Card.Header>
                    <strong>{translate('machine_list', 'Machine List')}</strong>
                </Card.Header>
                <Card.Body>
                    <MachineList machineSearchType="customer" entityId={customer?.entityId} customer={customer}/>
                </Card.Body>
            </Card>
        </div>
    );
};

export default CustomerMachines;